import React from 'react'

export default function FooterInfo() {
  const sectionStyle = {
    background: 'linear-gradient(90deg, #063547 60%, #7ee8fa 100%)',
    color: '#fff',
    padding: '2.2rem 0 1.2rem 0',
    margin: '0 auto 1.5rem auto',
    borderRadius: '18px 18px 0 0',
    fontFamily: 'inherit',
    fontSize: '1.08rem',
    letterSpacing: '0.01em',
  };
  // Social icon brand colors
  const socialColors = {
    facebook: '#1877f3',
    twitter: '#1da1f2',
    linkedin: '#0a66c2',
    instagram: '#0a66c2',
  };
  const iconStyle = {
    fontSize: '1.3rem',
    verticalAlign: 'middle',
    transition: 'color 0.18s, transform 0.18s, background 0.18s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2.2em',
    height: '2.2em',
    borderRadius: '50%',
  };
  // Add a style tag for hover effect
  const iconHoverCSS = `
    .info_social a:hover i {
      background: rgba(255,255,255,0.18);
      transform: scale(1.18);
      box-shadow: 0 2px 8px 0 rgba(99,102,241,0.10);
    }
  `;
  const iconContactStyle = {
    color: '#7ee8fa',
    fontSize: '1.1em',
    marginRight: '0.5em',
    verticalAlign: 'middle',
  };
  return (
    <div>
      <section className="info_section layout_padding2" style={sectionStyle}>
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-6 info-col">
              <div className="info_detail">
                <h4 style={{color:'#ffe066', fontWeight:700, letterSpacing:'0.5px'}}>About Us</h4>
                <p style={{color:'#fff', fontWeight:500, fontSize:'1.05rem'}}>
                  A digital library is a universe of knowledge at your fingertips.
                </p>
                <style>{iconHoverCSS}</style>
                <div className="info_social" style={{marginTop:'0.5em'}}>
                  <a href="" style={{display:'inline-flex', alignItems:'center', justifyContent:'center', width:'2.2em', height:'2.2em'}}>
                    <i className="fab fa-facebook-f" aria-hidden="true" style={{...iconStyle, color: socialColors.facebook}}></i>
                  </a>
                  <a href="" style={{display:'inline-flex', alignItems:'center', justifyContent:'center', width:'2.2em', height:'2.2em'}}>
                    <i className="fab fa-twitter" aria-hidden="true" style={{...iconStyle, color: socialColors.twitter}}></i>
                  </a>
                  <a href="" style={{display:'inline-flex', alignItems:'center', justifyContent:'center', width:'2.2em', height:'2.2em'}}>
                    <i className="fab fa-linkedin" aria-hidden="true" style={{...iconStyle, color: socialColors.linkedin}}></i>
                  </a>
                  <a href="" style={{display:'inline-flex', alignItems:'center', justifyContent:'center', width:'2.2em', height:'2.2em'}}>
                    <i className="fab fa-instagram" aria-hidden="true" style={{...iconStyle, color: socialColors.instagram}}></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 info-col">
              <div className="info_contact">
                <h4 style={{color:'#ffe066', fontWeight:700, letterSpacing:'0.5px'}}>Address</h4>
                <div className="contact_link_box" style={{marginTop:'0.5em'}}>
                  <a href="" style={{color:'#fff', display:'flex', alignItems:'center', marginBottom:'0.5em'}}>
                    <i className="fa fa-map-marker" aria-hidden="true" style={iconContactStyle}></i>
                    <span>
                      136, Santhome High Road, < br /> Chennai - 600 028
                    </span>
                  </a>
                 {/*} <a href="" style={{color:'#fff', display:'flex', alignItems:'center', marginBottom:'0.5em'}}>
                    <i className="fa fa-phone" aria-hidden="true" style={iconContactStyle}></i>
                    <span>
                      +91 99711 86877
                    </span>
                  </a>
                  <a href="" style={{color:'#fff', display:'flex', alignItems:'center'}}>
                    <i className="fa fa-envelope" aria-hidden="true" style={iconContactStyle}></i>
                    <span>
                      vidyajyotilibrary@gmail.com
                    </span>
                  </a>*/}
                </div>
              </div>
            </div>
            {/* Newsletter and Map sections remain commented out */}
          </div>
        </div>
      </section>
    </div>
  );
}
